import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Logo",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 300 477.3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M243.2 393.8 80.9 350V84L0 63.3v347.6l243.2 66.4z",
      style: {"fill":"#ff550d"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M276.1 50.1 80.9 0v84L206 115.8l37.2 56.9v221.1l81.8 22.1V123.6z",
      style: {"fill":"#ff911d"}
    }, null, -1)
  ]))]))
}
export default { render: render }